










import { Component, Inject, InjectReactive, Vue } from 'vue-property-decorator';

import { FeedProduct } from '../../models';
import SimProJobsList from '@/components/tables/simPro.vue';
import { SimproJobDetails } from '@/api';

@Component({
	components: {
		SimProJobsList,
	},
})
export default class FeedProductSimproJobsTab extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	@Inject('setSimProJobsExist')
	public setSimProJobsExist!: (jobsExist: boolean) => void;

	public emitJobsExist(): void {
		// Only called from jobs list if incomplete jobs do exist.
		this.setSimProJobsExist(true);
	}
}
